import { render, staticRenderFns } from "./AddUpdateTag.vue?vue&type=template&id=7b0e2ad0&scoped=true"
import script from "./AddUpdateTag.vue?vue&type=script&lang=js"
export * from "./AddUpdateTag.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateTag.vue?vue&type=style&index=0&id=7b0e2ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0e2ad0",
  null
  
)

export default component.exports